import React from 'react';
import moment from 'moment';
import 'moment/locale/es';

const Comment = ({ comment, user, isCaseOpen }) => {
	return (
		<div className="comment-message-container">
			<div
				className={`comment-wrapper ${
					comment.enrollmentId ===
						user.enrollmentId
						? !isCaseOpen ? "is-my-message message-dark" : "is-my-message"
						: ""
					}`}
			>
				{comment.content}
				<span className="date-text">
					{`${moment(comment.createdAt).fromNow()}`}
				</span>
			</div>
		</div>
	)
}

export default Comment;